import axiosClient from 'src/api/axiosClient';
import { Alert, AlertRequestData, GetAlertsParams } from '../types';

export class AlertsApi {
  static async getAlerts(params?: GetAlertsParams): Promise<{ items: Alert[]; count: number }> {
    // Filter out undefined values to avoid sending empty parameters
    const cleanParams = params
      ? Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined))
      : {};

    const requestParams = {
      ...cleanParams,
      sort: cleanParams.sort || 'date_created_desc',
    };

    const response = await axiosClient.get(`/alerts`, {
      params: requestParams,
    });

    return {
      items: response.data.items,
      count: response.data.count,
    };
  }

  static async createAlert(data: AlertRequestData): Promise<Alert> {
    const response = await axiosClient.post(`/alerts`, data);
    return response.data;
  }

  static async updateAlert(alertId: string, data: AlertRequestData): Promise<Alert> {
    const response = await axiosClient.put(`/alerts/${alertId}`, data);
    return response.data;
  }

  static async deleteAlert(alertId: string): Promise<void> {
    await axiosClient.delete(`/alerts/${alertId}`);
  }
}
